import React__default from 'react';
import { Card, Price, AccordionItem, MediaQuery } from '@grandvisionhq/common';
import Reorder from '../../components/Reorder/Reorder.js';
import { CardGlassesConfiguration } from './CardGlassesConfiguration.js';

const OrderDetailCard = ({ children , billingFrequency , bundleChildLineItems , bundleConfiguration , configurationType , currency , discountPrice , footerType ='reorder' , imagePath , isReorderAvailable , labels , lineItemId , onReorder , price , quantity , subtitle , title  })=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    let priceDetail = null;
    if (billingFrequency) {
        priceDetail = `/ ${billingFrequency}`;
    } else if (discountPrice) {
        priceDetail = /*#__PURE__*/ React__default.createElement(Price, {
            type: "strikethrough",
            value: price,
            currency: currency
        });
    }
    return /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card, {
        className: "order-detail-card",
        layout: isPhone ? 'vertical' : 'horizontal',
        key: title
    }, /*#__PURE__*/ React__default.createElement(Card.Image, {
        alt: "",
        backgroundColor: "var(--color--shade-lightest)",
        className: "order-detail-card__image",
        src: imagePath
    }), /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Section, {
        className: "order-detail-card__details"
    }, /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Section, null, title ? /*#__PURE__*/ React__default.createElement(Card.Heading, {
        variant: "subheading1"
    }, title) : null), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        flex: true,
        className: "order-detail-card__subtitle"
    }, subtitle ? /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, subtitle) : null), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "s"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption"
    }, quantity))), /*#__PURE__*/ React__default.createElement(Card.Section, {
        spacing: "none",
        className: "order-detail-card__price"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption"
    }, discountPrice ? /*#__PURE__*/ React__default.createElement(Price, {
        value: discountPrice,
        currency: currency
    }) : /*#__PURE__*/ React__default.createElement(Price, {
        value: price,
        currency: currency
    }))), /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, priceDetail))), /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(PrescriptionSectionComponent, {
        children: children,
        labels: labels
    }), (bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.length) && configurationType === 'glasses' ? /*#__PURE__*/ React__default.createElement(AccordionItem, {
        variant: "narrow",
        label: labels.configuration,
        id: labels.configuration
    }, /*#__PURE__*/ React__default.createElement(CardGlassesConfiguration, {
        bundleConfiguration: bundleConfiguration,
        bundleChildLineItems: bundleChildLineItems
    })) : null), /*#__PURE__*/ React__default.createElement(Card.Section, null, footerType === 'reorder' ? /*#__PURE__*/ React__default.createElement(Reorder, {
        id: lineItemId,
        isReorderAvailable: isReorderAvailable,
        onReorder: onReorder
    }) : null))));
};
OrderDetailCard.PrescriptionSection = PrescriptionSectionComponent;
var OrderDetailCard$1 = OrderDetailCard;
function PrescriptionSectionComponent({ children , labels  }) {
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, (child)=>{
        if (!/*#__PURE__*/ React__default.isValidElement(child)) {
            return null;
        }
        if (child.type === OrderDetailCard.PrescriptionSection) {
            return /*#__PURE__*/ React__default.createElement(AccordionItem, {
                variant: "narrow",
                label: labels.prescription,
                id: labels.prescription
            }, child.props.children);
        }
        return null;
    }));
}

export { OrderDetailCard$1 as default };
//# sourceMappingURL=OrderDetailCard.js.map
